import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppImage from '../../../components/AppImage';

const BrandHeader = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/dashboard-home');
  };

  return (
    <div className="text-center mb-12">
      {/* Logo */}
      <div 
        className="inline-flex items-center cursor-pointer transition-micro hover:opacity-80"
        onClick={handleLogoClick}
      >
        <div className="flex items-center space-x-4">
          {/* Lion Crown Logo */}
          <div className="relative">
            <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center shadow-tier-2 cursor-pointer transition-transform duration-300 origin-top z-50 hover:scale-[4] hover:translate-y-10 md:hover:scale-[8] md:hover:translate-y-12">
              <AppImage
                src="/assets/images/major-high-logo.png"
                alt="Major High Logo"
                className="w-16 h-16 object-contain"
              />
            </div>
            
            {/* Heritage Badge */}
           {/*  <div className="absolute -top-1 -right-1 w-6 h-6 bg-secondary rounded-full flex items-center justify-center">
              <span className="text-xs font-bold text-secondary-foreground">MH</span>
            </div> */}
          </div>
          
          {/* Brand Text */}
          <div className="text-left">
            <h1 className="text-3xl font-heading font-bold text-foreground">
              Major High
            </h1>
            <p className="text-sm text-muted-foreground font-caption tracking-wide">
              ACADEMY PLATFORM
            </p>
          </div>
        </div>
      </div>
      
      {/* Tagline */}
      <p className="mt-6 text-lg text-muted-foreground font-caption max-w-md mx-auto">
        Transforme seu potencial em conquistas extraordinárias
      </p>
    </div>
  );
};

export default BrandHeader;